module.exports = __webpack_public_path__ + "img/logo-dusdata-s.fc98cf07.png";